export const POLICY_TOTALITARIANISM_MILITARY_BUILDINGS_WIN_POINTS_RATIO = 2;

export const POLICY_TOTALITARIANISM_BUILDING_DISCOUNT_ARSENAL_AND_MILITARY_CAMP = 2;

export const POLICY_TOTALITARIANISM_UNIT_RECRUITMENT_SIZE_D10 = 3;
export const POLICY_TOTALITARIANISM_UNIT_RECRUITMENT_SIZE_D20 = 6;
export const POLICY_TOTALITARIANISM_UNIT_RECRUITMENT_SIZE_D8 = 3;
export const POLICY_TOTALITARIANISM_UNIT_RECRUITMENT_SIZE_D12 = 4;

